module.exports = __webpack_public_path__ + "static/img/p3.5ec01bd8.png";